<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">{{
        $t("history.detail")
      }}</strong>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <a-form :layout="formLayout">
              <a-form-item
                v-for="key in Object.keys(details)"
                :key="key"
                :label="$t('cash.' + key)"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <span v-if="key == 'created'">{{
                  details[key] | formatDate
                }}</span>
                <span v-else>{{ details[key] }}</span>
              </a-form-item>
            </a-form>
          </div>
        </div>
        <div class="flex box-btn">
          <a-button @click="back">{{ $t("btn.back") }}</a-button>
          <a-popconfirm
            placement="topRight"
            title="You want to make sure that this transaction is right?"
            ok-text="Yes"
            cancel-text="No"
            v-show="showBtn"
            @confirm="confirm"
            @cancel="sayNo"
          >
            <a-button :loading="loading" type="primary">
              {{ $t("btn.confirm") }}
            </a-button>
          </a-popconfirm>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  data() {
    return {
      loading: false,
      details: {},
      formLayout: "horizontal",
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      loading: false,
      paid: 0,
    };
  },
  methods: {
    loadDetail() {
      this.api("admin/cash?cashId=" + this.$route.params.id).then((res) => {
        this.details = {
          room_name: res.roomName,
          user_name: res.userName,
          created: res.created,
          cash: helper.filters.formatMoney(res.cash),
          content: res.content,
          status: res.status,
        };
        this.roomId = res.roomId;
        this.uid = res.uid;
        console.log("details", res);
      });
    },
    confirm(e) {
      this.loading = true;
      this.api("admin/cashApply", {
        cashId: this.$route.params.id,
        roomId: this.roomId,
        uid: this.uid,
      })
        .then((res) => {
          console.log(res);
          this.$router.push("/admin_transaction");
        })
        .finally((e) => {
          this.loading = false;
        });
    },
    sayNo() {
      this.$message.info("Click on No");
    },
    back() {
      this.$router.push("/admin_transaction");
    },
  },
  mounted() {
    this.loadDetail();
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
          }
        : {};
    },
    showBtn() {
      return this.details.status == "new";
    },
  },
  mixins: [api, helper],
};
</script>
<style>
.box-btn {
  width: 100%;
  justify-content: flex-end;
  margin-top: 30px;
}
.box-btn button {
  width: 100px;
}
</style>